import { Box, styled } from '@mui/material';

export const StyledOldTurnaroundBox = styled(Box)`
    height: 50px;
    border: 1px dashed white;
    position: absolute;
    top: 0;
    left: 0;
`;
